import { getServerRequest, patchServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const cargarNotificacionesService = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/notificaciones`;
    return await getServerRequest(url, config);
}

export const limpiarNotificacionesService = async (idUsuario) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/notificaciones/eliminar/${idUsuario}`;
    return await patchServerRequest(url, {}, config);
}